module.exports = __webpack_public_path__ + "b3377fa9907231577cd694cf6f5062d5.png";